export const QUICK_REPLY_ANALYTICS_SCOPE = 'jiraQuickReply';
export const QUICK_REPLY_ANALYTICS_VALID = 'validQueryParam';
export const QUICK_REPLY_ANALYTICS_INVALID = 'invalidQueryParam';
